import api from '../../utils/api'

const state = {
  grading: {}
}

const getters = {
  getGrading (state) {
    return state.grading
  }
}

const actions = {
  setGrading (contaxt, grading) {
    contaxt.commit('SET_GRADING', grading)
  },
  setDiseases (contaxt, diseases) {
    contaxt.commit('SET_DISEASES', diseases)
  },
  setIsDoctor (contaxt, isDoctor) {
    contaxt.commit('SET_IS_DOCTOR', isDoctor)
  },
  setEyes (contaxt, data) {
    contaxt.commit('SET_EYES', { ...data })
  },
  setEyesResult (contaxt, data) {
    contaxt.commit('SET_EYES_RESULT', { ...data })
  },
  getGradings ({ commit }, payload) {
    return api('/api/gradings', 'GET', payload)
  },
  getAllGradings ({ commit }, payload) {
    return api('/api/gradings/all', 'GET', payload)
  },
  saveRecords ({ commit }, payload) {
    return api('/api/records', 'POST', payload)
  },
  getRecords ({ commit }, payload) {
    return api('/api/records', 'GET', payload)
  },
  saveRecordHistory ({ commit }, payload) {
    return api('/api/history', 'POST', payload)
  },
  getLastHistory ({ commit }, payload) {
    return api('/api/history', 'GET', payload)
  },
  updateGrading ({ commit }, payload) {
    return api('/api/grading', 'PUT', payload)
  }
}

const mutations = {
  SET_GRADING (state, { grading }) {
    state.grading = grading
  },
  SET_DISEASES (state, { diseases }) {
    state.grading.diseases = diseases
  },
  SET_EYES (state, { type, eye }) {
    state.grading[type] = eye
  },
  SET_EYES_RESULT (state, { eye, result }) {
    state.grading[eye].result = result
  },
  SET_IS_DOCTOR (state, { isDoctor }) {
    state.grading.isDoctor = isDoctor
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
